<template>
  <a-row :gutter="16">
    <a-col :md="24" :lg="16">
      <a-form layout="horizontal" :label-col="{ span: 4 }">
        <a-form-item label="上传人">
          <span>{{ baseInfo.operator }}</span>
        </a-form-item>
        <a-form-item label="上传时间">
          <span>{{ baseInfo.updateTime }}</span>
        </a-form-item>
        <a-form-item label="提示" required>
          <span>{{ baseInfo.hintMsg }}</span>
        </a-form-item>
      </a-form>
    </a-col>

    <a-col
      :md="24"
      :lg="8"
      :style="{ minHeight: '180px', textAlign: 'center' }"
    >
      <div
        class="ant-upload-preview"
        @click="handleClick"
        v-if="baseInfo.type == 1"
      >
        <a-icon type="cloud-upload-o" class="upload-icon" />
        <div class="mask">
          <a-icon type="plus" />
        </div>
        <img :src="img" />
      </div>
      <slot v-else-if="baseInfo.type == 2"></slot>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'BaseInfo',
  props: ['img', 'baseInfo'],
  methods: {
    handleClick() {
      this.$emit('handleClickImg')
    },
  },
}
</script>

<style lang="less" scoped>
// .avatar-upload-wrapper {
//   height: 200px;
//   width: 100%;
// }

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
